import * as React from "react"

export type LogoProps = {
  color?: string
  fill?: string
}

export const LogoDark = (props: LogoProps) => {
  const { color = "currentColor", fill } = props

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="6" fill={fill} />
      <path
        d="M9.0625 1.625C7.40188 2.72489 5.74126 3.84635 4.08064 4.94624C3.34738 5.50697 3.36895 6.36963 3.86498 7.08132L9.04094 3.60912L9.0625 1.625Z"
        fill={color}
      />
      <path
        d="M2.9375 10.5813C4.59812 9.48143 6.25874 8.35998 7.91936 7.26008C8.65262 6.69935 8.63106 5.83669 8.13503 5.125L2.95907 8.59721L2.9375 10.5813Z"
        fill={color}
      />
    </svg>
  )
}
